import React from 'react';
import './SecondPage.css';

const items = [
  { id: 1, title: 'പുരയിടകൃഷി' },
  { id: 2, title: 'മണ്ണ് സംരക്ഷണം' },
  { id: 3, title: 'കൃഷിയിലെ ഞാറ്റുവേലകൾ' },
  { id: 4, title: 'ജൈവവളങ്ങൾ' },
  { id: 5, title: 'നാടൻ വിത്തുകൾ' },
  { id: 6, title: 'കീടരോഗ നിയന്ത്രണം' },
  { id: 7, title: 'പച്ചകക്ക പൊടി vs കുമ്മായം' },
  { id: 8, title: 'ചേനകൃഷി' },
  { id: 9, title: 'നെൽവിത്ത് മുളപ്പിക്കൽ' },
];

const SecondPage = () => {
  const openDetail = (id) => {
    window.location.hash = `#/practical/${id}`;
  };
  return (
    <section id="second" className="section second-page">
      <div className="container">
        <div className="second-title">
          <h2 className="second-heading malayalam-heading">പുരയിട കൃഷി<br/>പ്രായോഗിക പാഠങ്ങൾ</h2>
        </div>
        <div className="grid second-grid">
          {items.map((it) => (
            <button
              key={it.id}
              className="card second-box"
              onClick={() => openDetail(it.id)}
              style={{ textAlign: 'center', fontWeight: 600 }}
            >
              {it.title}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SecondPage;
